module.exports = __webpack_public_path__ + "img/xuanzhuan1.961677db.png";